export const apiFetch = (
  input: RequestInfo | URL,
  init?: RequestInit | undefined
): Promise<Response> => {
  if (init && init.headers) {
    return fetch(input, {
      ...init,
      headers: { ...init.headers, Authenticate: localStorage.getItem('accessToken') || '' },
    });
  }

  return fetch(
    input,
    init ? { ...init, headers: { Authenticate: localStorage.getItem('accessToken') || '' } } : init
  );
};
